import { backgroundTransitionOnClick, IconFont, pointer, singleTextEllipsis } from '@byecode/ui'
import styled from 'styled-components'

export const Icon = styled(IconFont)<{ size?: number; isAction?: boolean; isHidePointer?: boolean }>`
    font-size: ${({ size }) => size ?? '16'}px;
    background-color: transparent;
    ${({ isHidePointer }) => !isHidePointer && pointer}

    ${({ isAction }) => isAction && `${backgroundTransitionOnClick}`}
`
